import { useRef, useState } from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import { router } from '@inertiajs/react';
import { CloseIcon } from '../../assets/icons/icons';
import SatisfactionScale from './SatisfactionScale';
import CSATModal from './CSATModal';

export default function CSAT({ onDismiss }) {
  const [rating, setRating] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const submittingRef = useRef(false);

  const handleSubmit = () => {
    if (rating === 0 || submittingRef.current) return;
    submittingRef.current = true;
    router.post('/surveys', {
      survey: { type: 'CsatSurvey', data: { rating, page: window.location.pathname } },
    }, { preserveState: true, preserveScroll: true });
    onDismiss();
  };

  const handleModalSubmit = (data) => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    router.post('/surveys', {
      survey: { type: 'CsatSurvey', data: { ...data, page: window.location.pathname } },
    }, { preserveState: true, preserveScroll: true });
    setModalOpen(false);
    onDismiss();
  };

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          bgcolor: 'common.white',
          boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
          zIndex: 1300,
          py: 2,
          px: 3,
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-evenly"
          gap={1}
          flexWrap="wrap"
        >
          <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ width: { xs: '100%', sm: 'auto' } }}>
            <Typography variant="body1">
              What is your overall satisfaction with SVCE's eHub?
            </Typography>
            <IconButton onClick={onDismiss} aria-label="Close survey" size="small" sx={{ display: { sm: 'none' } }}>
              <CloseIcon />
            </IconButton>
          </Box>

          <SatisfactionScale value={rating} onChange={setRating} />

          <Box display="flex" alignItems="center" gap={2}>
            <Button
              variant="outlined"
              color="svceGreen"
              onClick={handleSubmit}
              disabled={rating === 0}
              sx={{
                fontWeight: 600,
                textTransform: 'uppercase',
                borderRadius: '4px',
                px: 3,
              }}
            >
              Submit
            </Button>

            <Button
              onClick={() => setModalOpen(true)}
              sx={{
                color: 'primary.main',
                fontWeight: 600,
                textTransform: 'uppercase',
                fontSize: '0.875rem',
                whiteSpace: 'nowrap',
              }}
            >
              More Feedback?
            </Button>

            <IconButton onClick={onDismiss} aria-label="Close survey" size="small" sx={{ display: { xs: 'none', sm: 'flex' } }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </Box>

      <CSATModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmit={handleModalSubmit}
        initialRating={rating}
      />
    </>
  );
}
